import { useQuery } from "@tanstack/react-query";
import api from "../../../services/api";
import { tagsQueryKeys } from "../queryKeys";

const useGetUserTags = (hash: string) => {
  const { data, isPending } = useQuery({
    queryKey: tagsQueryKeys.getUserTags(hash),
    queryFn: () => api.getUserTags(hash),
    select: ({ data: selectData }) =>
      selectData.map(({ tag }: { tag: string }) => tag)
  });

  return { data, isLoading: isPending };
};

export default useGetUserTags;
